export default __webpack_public_path__ + "static/media/youtube.e6bd7d23.svg";